<template>
  <aside class="vjs-cta" v-if="playerEnded">
    <div v-if="cta?.selected === 'text' || cta?.selected === 'pdf'">
      <p v-if="cta?.link">
        <a :href="absoluteLink(cta?.link)" target="_blank" @click="closeCTA">{{ cta?.text }} </a>
      </p>
      <p v-else @click="closeCTA">{{ cta?.text }}</p>
    </div>
    <p @click="closeCTA" v-if="cta?.selected === 'pdf'">
      <small class="pdf-link">
        <a :href="cta?.filePath" target="_blank" rel="noreferrer">
          {{ $t('AllTraslation.viewPDF') }}
          <img
            src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI2IDI2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNiAyNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8Zz4KCTxwYXRoIGQ9Ik0xOCwxNy43NTl2My4zNjZDMTgsMjIuMTU5LDE3LjE1OSwyMywxNi4xMjUsMjNINC44NzVDMy44NDEsMjMsMywyMi4xNTksMywyMS4xMjVWOS44NzUgICBDMyw4Ljg0MSwzLjg0MSw4LDQuODc1LDhoMy40MjlsMy4wMDEtM2gtNi40M0MyLjE4Miw1LDAsNy4xODIsMCw5Ljg3NXYxMS4yNUMwLDIzLjgxOCwyLjE4MiwyNiw0Ljg3NSwyNmgxMS4yNSAgIEMxOC44MTgsMjYsMjEsMjMuODE4LDIxLDIxLjEyNXYtNi4zNjdMMTgsMTcuNzU5eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPGc+CgkJPHBhdGggZD0iTTIyLjU4MSwwSDEyLjMyMmMtMS44ODYsMC4wMDItMS43NTUsMC41MS0wLjc2LDEuNTA0bDMuMjIsMy4yMmwtNS41Miw1LjUxOSAgICBjLTEuMTQ1LDEuMTQ0LTEuMTQ0LDIuOTk4LDAsNC4xNDFsMi40MSwyLjQxMWMxLjE0NCwxLjE0MSwyLjk5NiwxLjE0Miw0LjE0LTAuMDAxbDUuNTItNS41MmwzLjE2LDMuMTYgICAgYzEuMTAxLDEuMSwxLjUwNywxLjEyOSwxLjUwNy0wLjc1N0wyNiwzLjQxOUMyNS45OTktMC4wMTgsMjYuMDI0LTAuMDAxLDIyLjU4MSwweiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="
            alt="redirect_icon" />
        </a>
      </small>
    </p>
    <a @click="closeCTA" v-else-if="cta?.selected === 'image'" :href="absoluteLink(cta?.link)" target="_blank" rel="noreferrer"><img
        :src="cta?.imageUrl" alt="" />
    </a>
  </aside>
</template>

<script >
import { defineComponent } from "vue";
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'
import { mapGetters } from "vuex";
export default defineComponent({
  name: "interacitive-cta",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    player: {
      required: true,
      type: Object,
    },
  },
  computed: {
    cta() {
      return this.setVideoInfos?.interactivityOptions?.data?.cta || {};
    },
  
    ...mapGetters(['setVideoInfos'])
  },
  data() {
    return {
      playerEnded: false,
      markers: [], 
      ctaDisplayed: false, 
      ctaMarkerClicked: false, 


    };
  },
  watch: {
    player() {
      this.player.on("timeupdate", () => {
        if (Object.keys(this.cta).length > 0 && !this.ctaDisplayed) {
          const currentTime = Math.floor(this.player.currentTime());
          if (this.cta.start === currentTime && this.cta.start!=Math.floor(this.player.duration())) {
            this.player.pause(); 
            this.playerEnded = true;
            this.ctaDisplayed = true; 
          } else if (this.player.duration() === this.player.currentTime() && this.cta.start===Math.floor(this.player.duration())) {
            this.player.pause(); 
            this.playerEnded = true;
            this.ctaDisplayed = true; 

          }else{
              // The player is already playing, close the CTA
              this.closeCTA();
            }
        }
        
      });
    },
  },
  methods: {
    absoluteLink(link) {
      if (link.includes("https")) {
        return link;
      } else {
        return `https://${link}`;
      }
    },
    
    addPlayButtonEventListener() {
      const playButton = document.querySelector(".vjs-play-control");

      if (playButton ) {
        playButton.addEventListener("click", () => {
          this.closeCTA();
        });
      }
    },
    
    
   
    closeCTA() {
      if (this.ctaDisplayed) {
        const currentTime = this.player.currentTime();
        this.player.currentTime(currentTime + 1);
        this.player.play();
        this.playerEnded = false;
        this.ctaDisplayed = false;
      }
    },

  
  
  },
  mounted() {
  this.addPlayButtonEventListener();
},

});
</script>

<style>

.vjs-cta a {
  text-decoration: none;
  box-sizing: inherit;
  font-size: inherit;
  color: inherit;
}

.vjs-cta a:hover {
  text-decoration: underline;
}

.vjs-cta {
  background: var(--vm-color-one-08) ;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  font-size: 9vw;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  z-index: 2;
}

.vjs-cta.is-active {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
}

.vjs-cta .pdf-link a {
  font-size: 0.5em;
  text-decoration: none;
}

.vjs-cta .pdf-link a img {
  height: 0.8em;
  vertical-align: inherit;
}
</style>
